import {takeLatest, put, call} from 'redux-saga/effects';
import apiCall from '../../api';
import {UPDATE_CDC_CARD_ERROR, UPDATE_CDC_CARD_START, UPDATE_CDC_CARD_SUCCESS} from "../../types";

export function* update({payload}) {
    try {
        const url = `/cdc_card_caregories/${payload.formData.id}/`;
        const method = 'PUT';
        const headers = {Authorization: 'Bearer ' + payload.token, 'Content-Type':'multipart/form-data'};
        const data = (object) => Object.keys(object).reduce((formData, key) => {
            formData.append(key, object[key]);
            return formData;
        }, new FormData());
        const results = yield call(apiCall, url, method, data(payload.formData), headers);
        yield put({type: UPDATE_CDC_CARD_SUCCESS, results: results.data});
        yield put(payload.navigate('/app/content-management/manage-card-category'));
    } catch (error) {
        yield put({type: UPDATE_CDC_CARD_ERROR, error});
    }
}

export default function* update_card_category() {
    yield takeLatest(UPDATE_CDC_CARD_START, update);
}